<template>
  <div>
    <div class="content-bottom-padded">
      <el-row class="content-bottom-padded" :gutter="20">
        <el-col :span="20">
          <category-select style="width:100%" distributors @update="storeSearch"
                           :shopIdDefault="distributor_id"></category-select>
        </el-col>
      </el-row>
      <el-button type="primary" slot="reference" size="mini" @click="add()">添加分类</el-button>
      <el-button type="primary" slot="reference" v-if="distributor_id >1" size="mini" @click="syncAction()">
        同步当前店铺分类到指定店铺
      </el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="(item,index) in tabList" :key="index" :label="item.name" :name="item.activeName">
        <el-table :data="list" style="width: 100%" :height="wheight-240" v-loading="loading" ref="multipleItemsTable"
                  @selection-change="handleItemsSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="category_name" label="分类名称" min-width="200"></el-table-column>
          <el-table-column label="分类状态(显示/隐藏)">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" @change="changeStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="is_point" label="排序" min-width="120">
            <template slot-scope="scope">
              <el-input placeholder="分类排序" v-model="scope.row.sort" @blur="sortblur($event,scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="200">
            <template slot-scope="scope">
              <el-button type="text" slot="reference" size="mini" @click="edit(scope.row)">编辑</el-button>
              <el-button type="text" slot="reference" size="mini" @click="deldialog(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-padded content-center">
          <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="params.page"
              :page-sizes="[10,20,50]"
              :total="total_count"
              :page-size="params.pagesize">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="title" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="form">
        <el-form-item label="分类名称">
          <el-input placeholder="分类名称" v-model="form.category_name"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input placeholder="排序" v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status"></el-switch>
        </el-form-item>
        <el-form-item label="同步至其他店铺">
          <el-switch v-model="form.isSyncAll"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit('form')">确 定</el-button>
      </div>
    </el-dialog>
    <!--同步所有分类start-->
    <el-dialog :title="SyncDataTitle" :visible.sync="syncDataVisible" :before-close="handleCancel">
      <template>
        <el-form ref="form" :model="syncForm" class="demo-ruleForm" label-width="120px">
          <el-form-item label="指定店铺">
            <el-tag size="mini" type="warning" @click="closeAll()" v-if="relDistributors.length >0"
                    style="cursor:pointer;">清空全部
            </el-tag>
            <el-tag :key="item.distributor_id" class="new-tag" v-for="(item,index) in relDistributors" closable
                    :disable-transitions="false" @close="handleClose(index)"> {{ item.name }}
            </el-tag>
            <el-button size="medium" class="button-new-tag" @click="addDistributoreAction">+ 点击搜索店铺</el-button>
          </el-form-item>
          <el-form-item label="按标签同步">
            <el-select v-model="tag_ids" multiple placeholder="店铺标签">
              <el-option
                  v-for="item in distributor_tags"
                  :key="item.tag_id"
                  :label="item.tag_name"
                  :value="item.tag_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <p style="color:red;">
          注意：同步分类时会先删除门店原有分类数据，然后以当前门店分类为基准重新建立新的分类数据<br>
        </p>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="syncDataVisible = false">取消</el-button>
        <el-button type="primary" @click="syncAll()" :loading="submitLoading">
          {{ submitLoading ? '同步中' : '确认开始同步' }}
        </el-button>
      </div>
    </el-dialog>
    <!--同步所有分类end-->
    <el-dialog
        :title="title"
        :visible.sync="delVisible"
        width="30%"
        :before-close="handleCancel">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="指定店铺标签">
          <el-select v-model="tag_ids" multiple placeholder="店铺标签">
            <el-option
                v-for="item in distributor_tags"
                :key="item.tag_id"
                :label="item.tag_name"
                :value="item.tag_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <!-- <span>是否确认删除？</span><br> -->
          <el-switch v-model="form.isSyncAll"></el-switch>&nbsp;&nbsp;&nbsp;同时删除指定标签下店铺的分类数据
        </el-form-item>
      </el-form>
      <p style="color:red;">注意：如果当前分类下已有关联商品，则会先删除分类然后将其下商品重置为未分类。</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delVisible = false">取 消</el-button>
        <el-button type="primary" @click="del()">确 定</el-button>
      </span>
    </el-dialog>
    <DistributorSelect :store-visible="DistributorVisible"
                       :rel-data-ids="relDistributors"
                       :get-status="DistributorStatus"
                       @chooseStore="DistributorChooseAction"
                       @closeStoreDialog="closeDialogAction"></DistributorSelect>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../store'
import {mapGetters} from 'vuex'
import shopSelect from '@/components/shopSelect'
import categorySelect from '@/components/categorySelect'
import {
  getDistributorItems,
  getDistributorInfo,
  getTagList
} from '../../../api/marketing'
import {
  getMerchantItemsCategory,
  addMerchantItemsCategory,
  editMerchantItemsCategory,
  delMerchantItemsCategory,
  syncMerchantItemsCategory
} from '../../../api/merchant'
import DistributorSelect from '@/components/function/distributorSelect'

export default {
  components: {
    shopSelect,
    categorySelect,
    DistributorSelect
  },
  props: {
    distributorId: {
      type: String,
      default: ''
    },
    isLoad: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: '',
      title: '',
      show_sideBar: false,
      activeName: 'first',
      dialogtitle: '',
      total_count: 0,
      loading: false,
      itemCategoryList: [],
      SyncDataTitle: '',
      visible: true,
      syncDataVisible: false,
      DistributorVisible: false,
      delVisible: false,
      DistributorStatus: false,
      relDistributors: [],
      isSyncItem: false,
      isSyncSelect: false,
      distributor_id: '',
      distributor_ids: [],
      submitLoading: false,
      distributor_tags: [],
      tag_ids: [],
      params: {
        page: 1,
        pagesize: 50,
        distributor_id: '',
        keywords: '',
        is_can_sale: '_all'
      },
      list: [],
      itemsChecked: [],
      tabList: [
        {name: '全部店铺商品分类', value: null, activeName: 'first'}
      ],
      syncForm: {
        distributor_ids: [],
        tag_ids: [],
        isSyncAll: false
      },
      form: {
        category_name: '',
        now_distributor_id: '',
        isSyncAll: false,
        sort: 0,
        status: 1
      },
      dialogFormVisible: false,
      editStore: false,
      editType: false,
      itemSkuList: [],
      itemSkuParam: {
        is_sku: 'true'
      },
      rules: {
        category_name: {
          required: true,
          message: '商家编号!',
          trigger: 'blur'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    handleCancel () {
      this.editCategroyVisible = false
      this.syncDataVisible = false
      this.delVisible = false
    },
    handleClose (index) {
      this.relDistributors.splice(index, 1)
      this.distributor_ids.splice(index, 1)
    },
    getDistributorTagList () {
      getTagList({'page': 1, 'pageSize': -1}).then(res => {
        this.distributor_tags = res.data.data.list
      })
    },
    closeAll () {
      this.syncForm.distributor_ids = []
      this.relDistributors = []
    },
    DistributorChooseAction (data) {
      this.DistributorVisible = false
      this.DistributorStatus = false
      if (data === null || data.length <= 0) return
      this.relDistributors = data
    },
    closeDialogAction () {
      this.DistributorStatus = false
      this.DistributorVisible = false
    },
    storeSearch (val, name = '') {
      if (name != '') {
        this.$parent.titile_label = name
      }
      val && val.shop_id
      this.params.distributor_id = val.shop_id
      this.distributor_id = val.shop_id
      this.params.page = 1
      this.getList()
    },
    sortblur (e, row) {
      var val = e.target.value
      this.updateSort(val, row)
    },
    handleBatchOnline (goods_can_sale) {
      if (this.itemsChecked.length <= 0) {
        this.$message({type: 'error', message: '请至少选择一个商品'})
        return
      }
      var goodsIds = []
      this.itemsChecked.forEach(item => {
        goodsIds.push(item.goods_id)
      })
      var form = {
        'distributor_id': this.params.distributor_id,
        'goods_id': JSON.stringify(goodsIds),
        'is_can_sale': goods_can_sale
      }
      this.updateDistributorItemCatrgory(form)
    },
    handleSkuEdit (row) {
      if (row.is_total_store === false) {
        this.editStore = true
      } else {
        this.editStore = false
      }
      this.show_sideBar = true
      this.itemSkuParam.item_id = row.item_id
      this.itemSkuParam.distributor_id = this.params.distributor_id
      getDistributorItems(this.itemSkuParam).then(res => {
        this.itemSkuList = res.data.data.list
      })
    },
    handleClick (tab, event) {
      if (tab.name == 'second') {
        this.params.is_can_sale = true
      } else if (tab.name == 'third') {
        this.params.is_can_sale = false
      } else {
        this.params.is_can_sale = '_all'
      }
      this.params.page = 1
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pagesize = pageSize
      this.getList()
    },
    add () {
      if (this.checkMerchant() == false) {
        return false
      }
      this.dialogFormVisible = true
      this.title = '添加分类'
      this.form = {}
      this.id = ''
    },
    edit (row) {
      this.form = row
      this.id = row.id
      this.dialogFormVisible = true
      this.title = '编辑分类'
    },
    deldialog (row) {
      this.form = row
      this.delVisible = true
      this.title = '删除分类'
    },
    onSubmit (formName) {
      console.log(this.form)
      this.form.now_distributor_id = this.distributor_id
      var submit = false
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log('error submit!!')
          return false
        } else {
          submit = true
        }
      })
      if (submit == false) {
        return
      }
      var that = this
      that.form.isSyncAll = that.form.isSyncAll === true ? 1 : 0
      that.form.status = that.form.status === true ? 1 : 0
      // console.log(that.form.isSyncAll);
      // return;
      if (that.id) {
        editMerchantItemsCategory(that.id, that.form).then((res) => {
          if (res.status) {
            that.loading = false
            that.$message({
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.dialogFormVisible = false
            setTimeout(function () {
              that.params.page = 1
              that.getList()
            }, 1000)
          } else {
            that.$message.error('修改失败!')
            return false
          }
        })
      } else {
        addMerchantItemsCategory(that.form).then((res) => {
          if (res.status) {
            that.loading = false
            that.$message({
              message: '保存成功',
              type: 'success',
              duration: 2000
            })
            that.dialogFormVisible = false
            setTimeout(function () {
              that.params.page = 1
              that.getList()
            }, 1000)
          } else {
            that.$message.error('保存失败!')
            return false
          }
        })
      }
    },
    //检查是否选择了店铺
    checkMerchant () {
      if (!this.params.distributor_id || this.params.distributor_id == 1) {
        this.$message({
          message: '请选择一个店铺后进行操作!',
          type: 'error'
        })
        return false
      } else {
        return true
      }
    },
    del () {
      var that = this
      this.form.tag_ids = this.tag_ids // 按店铺标签删除分类数据
      this.form.isSyncAll = this.form.isSyncAll == true ? 1 : 0
      delMerchantItemsCategory(that.form.id, that.form).then((res) => {
        that.loading = true
        if (res.status) {
          that.loading = false
          this.$message({
            message: '已删除',
            type: 'success',
            duration: 2000
          })
          setTimeout(function () {
            that.list.splice(index, 1)
          }, 1000)
          this.delVisible = false
          that.getList()
        }
      })
    },
    addDistributoreAction () {
      this.DistributorVisible = true
      this.DistributorStatus = true
    },
    // 同步到其他门店
    sync () {
      if (this.itemsChecked == '') {
        this.$message({
          type: 'error',
          message: '请先选择分类!',
          duration: 1000
        })
        return false
      }
      this.$confirm('同步分类只能同步状态为已显示的分类,确认同步？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.loading = true
            syncMerchantItemsCategory({
              formdata: this.itemsChecked,
              distributor_id: this.distributor_id
            }).then(response => {
              if (response.data.data.status == 1) {
                this.loading = false
                this.$message({
                  type: 'success',
                  message: '同步成功!',
                  duration: 1000
                })
              } else {
                this.loading = false
                this.$message({
                  type: 'error',
                  message: response.data.data.msg,
                  duration: 1000
                })
              }
            })
          }
          done()
        }
      })
    },
    syncAction () {
      console.log(this.itemsChecked)
      if (!this.distributor_id) {
        this.$message({
          type: 'error',
          message: '请选择一个店铺开始同步!'
        })
        return false
      }
      if (this.itemsChecked == '') {
        this.$message({
          type: 'error',
          message: '请先选择分类!',
          duration: 1000
        })
        return false
      }
      this.SyncDataTitle = '同步分类'
      this.syncDataVisible = true
    },
    // 同步到其他门店
    syncAll () {
      // 要同步的店铺id
      if (this.relDistributors.length > 0) {
        this.relDistributors.forEach(distributor => {
          this.syncForm.distributor_ids.push(distributor.distributor_id)
        })
      }
      if (this.relDistributors.length <= 0 && this.tag_ids.length <= 0) {
        this.$message({
          type: 'error',
          message: '请至少选择一个店铺或标签!',
          duration: 1000
        })
        this.submitLoading = false
        return false
      }
      // } else {
      //   // 至少选择一个店铺进行同步
      //   if (this.syncForm.isSyncAll == false) {
      //     this.$message({
      //       type: 'error',
      //       message: '请至少选择一个店铺进行同步!',
      //       duration: 1000
      //     })
      //     this.submitLoading = false
      //     return false
      //   }
      this.submitLoading = true
      let params = {
        isSyncAll: 0,
        distributor_ids: this.syncForm.distributor_ids,
        tag_ids: this.tag_ids,
        formdata: this.itemsChecked,
        now_distributor_id: this.distributor_id
      }
      syncMerchantItemsCategory(params).then(response => {
        if (response.data.status == 1) {
          this.syncDataVisible = false
          this.submitLoading = false
          this.$message({
            type: 'success',
            message: '同步成功!',
            duration: 1000
          })
        } else {
          this.syncDataVisible = false
          this.submitLoading = false
          this.syncForm.isSyncAll = false
          this.syncForm.distributor_ids = []
          this.$message({
            type: 'error',
            message: response.data.data.msg,
            duration: 1000
          })
        }
      })
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getList()
    },
    getList () {
      var _data = {}
      this.loading = true
      _data.distributor_id = this.distributor_id
      _data.pagesize = this.params.pagesize
      _data.page = this.params.page
      getMerchantItemsCategory(_data).then(response => {
        if (response.data.data) {
          this.list = response.data.data.list
          this.total_count = response.data.data.total_count
        }
        this.loading = false
      })
    },
    handleItemsSelectionChange (val) { // 商品选择
      var arr = []
      for (var i = 0; i < val.length; i++) {
        arr.push({
          category_id: val[i].id,
          category_name: val[i].category_name,
          status: val[i].status,
          sort: val[i].sort
        })
      }
      this.itemsChecked = arr
    },
    updateSort (id, row) {
      var that = this
      // row.status = row.status === true ? 1 : 0
      editMerchantItemsCategory(row.id, {
        sort: row.sort,
        distributor_id: this.distributor_id
      }).then(res => {
        this.getList()
        that.$message({
          message: '修改状态成功',
          type: 'success',
          duration: 1000
        })
      })
    },
    changeStatus (row) {
      if (this.checkMerchant() == false) {
        return false
      }
      var that = this
      var status = row.status == true ? 1 : 0
      editMerchantItemsCategory(row.id, {
        status: status,
        distributor_id: this.distributor_id
      }).then((res) => {
        if (res.status) {
          that.loading = false
          that.$message({
            message: '修改状态成功',
            type: 'success',
            duration: 2000
          })
        } else {
          that.$message.error('修改状态失败!')
          return false
        }
      })
    },
    switchRecommendChange (index, row) {
      let form = {}
      form = {
        'distributor_id': this.params.distributor_id,
        'category_id': row.category_id,
        'dis_recommend': row.dis_recommend
      }
      this.updateDistributorItemCatrgory(form)
    },
    goodsNumberSearch () {
      this.params.page = 1
      this.getList()
    },
    async getDefaultDistributor (id) {
      let params = {distributor_id: id ? id : 0}
      let {data} = await getDistributorInfo(params)
      let distributor = data.data
      this.$parent.titile_label = distributor.name
      if (distributor) {
        return distributor
      } else {
        this.$router.go(-1)
      }
    },
    async getDistributorItemList () {
      let distributor = await this.getDefaultDistributor(this.params.distributor_id)
      if (!this.params.distributor_id && distributor) {
        this.params.distributor_id = distributor.distributor_id
      }
    },
    saveStore (store, row) {
      let form = {}
      form = {'distributor_id': this.params.distributor_id, 'item_id': row.item_id, 'store': store}
      this.updateDistributorItemCatrgory(form)
    }
  },
  mounted () {
    this.getDistributorTagList()
    if (this.$route.query.distributor_id) {
      this.distributor_id = this.$route.query.distributor_id
      this.params.distributor_id = this.$route.query.distributor_id
      this.form.now_distributor_id = this.$route.query.distributor_id
    }
    this.$nextTick(() => {
      if (this.isLoad) {
        if (!this.distributorId) {
          this.getDistributorItemList()
        } else {
          this.params.distributor_id = this.distributorId
          this.getDistributorItemList()
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// categorylist.vue?42bc5eca